import { inject, Injectable } from '@angular/core';
import { catchError, forkJoin, Observable, of, take } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiHttpService } from '../../../services';
import { CustomHttpResponse, DocumentSections, SupplierInvoiceItem } from '../../../models';
import { SectionsFor } from '../../../types';

@Injectable({
  providedIn: 'root',
})
export class SupplierInvoiceItemService {
  apiService: ApiHttpService<SupplierInvoiceItem> = inject(ApiHttpService<SupplierInvoiceItem>);

  // getForSupplierInvoice(supplierInvoiceIri: string): Observable<HydraCollectionResponse<SupplierInvoiceItem>> {
  //   return this.apiService.getMany(`${supplierInvoiceIri}/supplier_invoice_items`).pipe(
  //     take(1),
  //     map((result: CustomHttpResponse<HydraCollectionResponse<SupplierInvoiceItem>>) => result.body), // Extract the body from the response
  //     catchError((error) => {
  //       console.error(`Error fetching supplierInvoiceItems for supplierInvoiceId ${supplierInvoiceIri}:`, error);
  //       return of(null);
  //     }),
  //     filter((item: HydraCollectionResponse<SupplierInvoiceItem> | null) => !!item),
  //   );
  // }

  get(iri: string): Observable<SupplierInvoiceItem> {
    return this.apiService.get(iri).pipe(map((result: CustomHttpResponse<SupplierInvoiceItem>) => result.body));
  }

  getForSupplierInvoiceSection(iris: string[]): Observable<DocumentSections<SupplierInvoiceItem>> {
    const requests = iris.map((iri) =>
      this.apiService.getMany(`${iri}/supplier_invoice_items`).pipe(
        map((res) => ({ iri, items: res.body['hydra:member'] as SupplierInvoiceItem[] })),
        // keep the key even if one call fails
        catchError(() => of({ iri, items: [] })),
      ),
    );

    return forkJoin(requests).pipe(
      map((pairs) => {
        // Start as a partial of the exact-keys type, then return it
        const acc: Partial<SectionsFor<readonly string[], SupplierInvoiceItem>> = {};
        for (const { iri, items } of pairs) acc[iri] = items;
        return acc as SectionsFor<typeof iris, SupplierInvoiceItem>;
      }),
    );
  }

  patch(
    iri: string,
    updatedRecord: Record<string, string | number | null | boolean | undefined> | SupplierInvoiceItem,
  ): Observable<SupplierInvoiceItem> {
    return this.apiService.patch(iri, updatedRecord as unknown as SupplierInvoiceItem).pipe(
      take(1),
      map((result: CustomHttpResponse<SupplierInvoiceItem>) => result.body),
    );
  }
}
